import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import { relativeLoader } from 'src/common/utils/imageHelpers';
import { PATHS, NEXT_STATIC_IMAGES } from 'src/common/constants';
import PitchPageLayout from 'src/common/components/PitchPageLayout';
import Typography from 'src/common/components/Typography';
import Button from 'src/common/components/ButtonDS22';
import styles from './Recommendations.module.scss';

type Recommendation = { id: number };

const list: Recommendation[] = [
  { id: 0 },
  { id: 1 },
];

const Recommendations: FC = () => {
  const [t] = useTranslation('for-owners-page');

  return (
    <PitchPageLayout backgroundColor="midnight02">
      <div className={styles.root}>
        <div className={styles.title}>
          <Typography
            type="h2"
            size="display-4"
          >
            {t('recommendations--title')}
          </Typography>
        </div>
        <ul className={styles.list}>
          {list.map((item) => (
            <li className={styles.listItem} key={item.id}>
              <div className={styles.imageWrapper}>
                <Image
                  src={`${NEXT_STATIC_IMAGES}for-owners/recommendation-${item.id}-img.jpg`}
                  loader={relativeLoader}
                  width={590}
                  height={232}
                  loading="lazy"
                  alt={t(`recommendations--item-${item.id}--alt-text`)}
                />
              </div>
              <article className={styles.article}>
                <div className={styles.quote}>
                  <Typography
                    type="h3"
                    size="heading-5"
                    weight="semibold"
                  >
                    {t(`recommendations--item-${item.id}--quote`)}
                  </Typography>
                </div>
                <div className={styles.author}>
                  <Typography
                    type="p"
                    size="body-l"
                    weight="semibold"
                  >
                    {t(`recommendations--item-${item.id}--author`)}
                  </Typography>
                </div>
                <div className={styles.location}>
                  <Typography
                    type="p"
                    size="body-l"
                  >
                    {t(`recommendations--item-${item.id}--location`)}
                  </Typography>
                </div>
              </article>
            </li>
          ))}
        </ul>
        <Button
          type="link"
          href={PATHS.ADMIN_LISTINGS}
          variant="tertiary"
          fitWidth="m"
        >
          <Typography
            size="body-xl"
            type="p"
            weight="semibold"
          >
            {t('button--get-started')}
          </Typography>
        </Button>
      </div>
    </PitchPageLayout>
  );
};

export default Recommendations;
